import request from '@/utils/request'

let SignadvApi = {
    /*签到列表*/
    signadvlist(data, errorback) {
        return request._post('/shop/plus.signadv.signadv/index', data, errorback);
    },
    /*获取档案列表*/
    archiveslist(data, errorback) {
        return request._post('/shop/plus.signadv.signadv/archives', data, errorback);
    },
    /*用户信息*/
    getUser(data, errorback) {
        return request._get('/shop/plus.signadv.signadv/getUser', data, errorback);
    },
    /*列表信息*/
    getList(data, errorback) {
        return request._get('/shop/plus.signadv.signadv/detailed', data, errorback);
    },
    /*绑定商品*/
    putProduct(data, errorback) {
        return request._get('/shop/plus.signadv.signadv/putProduct', data, errorback);
    },
    /*绑定商品列表*/
    putProductList(data, errorback) {
        return request._post('/shop/plus.signadv.signadv/putProductList', data, errorback);
    },
    /*取消绑定商品*/
    goRemove(data, errorback) {
        return request._get('/shop/plus.signadv.signadv/goRemove', data, errorback);
    },

    /*取消绑定商品*/
    putRules(data, errorback) {
        return request._post('/shop/plus.signadv.signadv/putRules', data, errorback);
    },

    /*取消绑定商品*/
    getSettingList(data, errorback) {
        return request._get('/shop/plus.signadv.signadv/getSettingList', data, errorback);
    },

    /*****************  Getsignadv 组件 ********************/

    /*商品列表信息*/
    productList(data, errorback) {
        return request._post('/shop/plus.signadv.signadv/productList', data, errorback);
    },
    /*商品分类信息*/
    categoryList(data, errorback) {
        return request._post('/shop/plus.signadv.signadv/categoryList', data, errorback);
    },

}
export default SignadvApi;



// WEBPACK FOOTER //
// ./src/api/signadv.js